import { useEffect } from "react";
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from "react-router-dom";
import * as Sentry from "@sentry/react";

if (["production", "development", "preview"].includes(`${process.env.REACT_APP_SENTRY_ENVIRONMENT}`)) {
  Sentry.init({
    // debug: process.env.NODE_ENV === "development",
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    allowUrls: [
      "https://hub.outputsports.com/",
      "https://hub.osdev.tech/",
      "https://develop.osdev.tech/",
      "https://hub-preview.osdev.tech/",
      "https://preview.osdev.tech/",
    ],
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
  });
}
